import LocationListDropdown from 'component/LocationListDropdown'
import ProfileButton from './profile-button'

function TopHeader() {
  return (
    <div className='flex items-center'>
      <div className='flex items-center '>
        <div class='mr-4'>{/* <LocationListDropdown /> */}</div>
        <div class='mr-2'></div>
        <div>
          <ProfileButton />
        </div>
      </div>
    </div>
  )
}

export default TopHeader
